document.addEventListener("DOMContentLoaded", function () {
  // Detect if URL includes '.lt' → Lithuanian version, else English by default
  const isLithuanian = window.location.hostname.includes(".lt");

  // Lithuanian translations
  const lithuanian = {
    // --- Static Translations ---
    "Spin & Save BIG!": "Sukite ir sutaupykite!",
    "Enter your full name and email to spin the wheel for a chance to win":
      "Įveskite savo vardą ir el. paštą, kad galėtumėte sukti ratą ir laimėti!",
    "Enter your Name": "Įveskite savo vardą",
    "Enter your Email": "Įveskite savo el. pašto adresą",
    "Enter your phone number": "Įveskite savo telefono numerį",
    "I agree to my personal data being stored and used to receive the newsletter":
      "Sutinku, kad mano duomenys būtų saugomi ir naudojami naujienlaiškiui gauti.",
    "Try Your Luck!": "Išbandykite sėkmę!",
    "Don't forget to copy your coupon code before closing.":
      "Nepamirškite nukopijuoti nuolaidos kodą prieš uždarydami langą.",
    "You won!": "Jūs laimėjote!",
    "Spin to win": "Sukite ir laimėkite",

    // --- Wheel Slices ---
    "Sorry": "Atsiprašome",
    "15% OFF": "15% NUOLAIDA",
    "Almost Near": "Beveik pasisekė",
    "No luck today": "Šiandien nepasisekė",
    "10% OFF": "10% NUOLAIDA",
    "Better Luck for Next Time!": "Kitą kartą pasiseks geriau!",
    "BUY ONE GET ONE FREE": "Pirk 1, gauk 1 nemokamai",
    "So Close": "Labai arti",
    "Almost won": "Beveik laimėjote",
    "25% OFF": "25% NUOLAIDA",

    // --- Buttons ---
    "Spin & win!": "Suk ir laimėk!",
    "Copy": "Kopijuoti",
    "Copied": "Nukopijuota",
  };

  // English default (kept unchanged)
  const english = {
    "drehe das Rad und gewinne einen Rabatt!": "Spin & Save BIG!",
    "Trage deinen Namen und deine E-Mail-Adresse ein, drehe das Rad und sichere dir deine Gewinnchance!":
      "Enter your full name and email to spin the wheel for a chance to win",
    "Gib deinen Namen ein": "Enter your Name",
    "Gib deine E-Mail-Adresse ein": "Enter your Email",
    "Gib deine Telefonnummer ein": "Enter your phone number",
    "Ich stimme zu, dass meine persönlichen Daten gespeichert und zum Erhalt des Newsletters verwendet werden.":
      "I agree to my personal data being stored and used to receive the newsletter",
    "Versuch dein Glück!": "Try Your Luck!",
    "Vergiss nicht, deinen Gutscheincode zu kopieren, bevor du das Fenster schließt.":
      "Don't forget to copy your coupon code before closing.",
    "Du hast gewonnen!": "You won!",
    "Entschuldigung": "Sorry",
    "20 % RABATT": "15% OFF",
    "Fast geschafft": "Almost Near",
    "Heute kein Glück": "No luck today",
    "10 % RABATT": "10% OFF",
    "Mehr Glück beim nächsten Mal!": "Better Luck for Next Time!",
    "Kostenloser Versand": "BUY ONE GET ONE FREE",
    "Bezahle 3 erhalte 1 gratis": "So Close",
    "Beinahe gewonnen": "Almost won",
    "25 % RABATT": "25% OFF",
    "Dreh & gewinn!": "Spin & win!",
    "Kopieren": "Copy",
    "Kopiert": "Copied",
    "Sukite ir laimėkite": "Spin to win"
  };

  const translations = isLithuanian ? lithuanian : english;
  const scriptRef =
    document.currentScript ||
    document.querySelector('script[src*="wheelify-it-translate.js"]');
  const logoAssetUrl = scriptRef?.dataset?.logoUrl || "";

  function translateElements() {
    // Regular text nodes
    document.querySelectorAll("body *").forEach(el => {
      if (el.childNodes.length === 1 && el.childNodes[0].nodeType === 3) {
        let text = el.textContent.trim();
        if (translations[text]) el.textContent = translations[text];
      }
    });

    // Input placeholders
    document.querySelectorAll("input").forEach(input => {
      const ph = input.getAttribute("placeholder");
      if (translations[ph]) input.setAttribute("placeholder", translations[ph]);
    });

    // SVG text
    document.querySelectorAll("svg text").forEach(t => {
      const txt = t.textContent.trim();
      if (translations[txt]) t.textContent = translations[txt];
    });

    // Copy button text
    document.querySelectorAll("button.copy-button, button.copied_text_only").forEach(btn => {
      const textNode = Array.from(btn.childNodes).find(n => n.nodeType === 3);
      if (!textNode) return;
      const btnText = textNode.textContent.trim();
      if (translations[btnText]) textNode.textContent = " " + translations[btnText];
    });

    // Win heading
    document.querySelectorAll("p.wheelify-text-heading").forEach(p => {
      const span = p.querySelector(".win_text");
      if (span) {
        const prefix = p.childNodes[0]?.textContent?.trim();
        if (translations[prefix]) {
          p.childNodes[0].textContent = translations[prefix] + ' "';
        }
      }
    });

    // Coupon notice
    document.querySelectorAll(".cc-spin-a-sale-clock-div").forEach(div => {
      const text = div.textContent.trim();
      if (isLithuanian && text.match(/Use your (Discount|discount) code/i)) {
        const coupon = div.querySelector("strong:nth-of-type(1)")?.textContent || "{{coupon_code}}";
        const time = div.querySelector("strong:nth-of-type(2)")?.textContent || "{{time}}";
        div.innerHTML =
          `Pasinaudokite savo nuolaidos kodu <strong>${coupon}</strong> per <strong>${time}</strong>`;
      } else if (!isLithuanian && text.includes("Dein Gutscheincode:")) {
        const coupon = div.querySelector("strong:nth-of-type(1)")?.textContent || "{{coupon_code}}";
        const time = div.querySelector("strong:nth-of-type(2)")?.textContent || "{{time}}";
        div.innerHTML =
          `Use your discount code <strong>${coupon}</strong> within <strong>${time}</strong> before it expires`;
      }
    });

    replaceWheelLogo();
    setupSpinTriggerDismiss();
  }

  function replaceWheelLogo() {
    if (!logoAssetUrl) return;

    document.querySelectorAll(".spinny-wheel-svg").forEach(svg => {
      if (!svg || svg.dataset.logoSwapped === "true") return;

      const coreCircle = svg.querySelector('g circle[cx="36"][cy="36"][r="36"]');
      const innerGroup = coreCircle?.closest("g");

      if (!innerGroup || innerGroup.dataset.logoSwapped === "true") return;

      const hasCenterDot = innerGroup.querySelector('circle[r="7.741"]');
      if (!hasCenterDot) return;

      while (innerGroup.firstChild) {
        innerGroup.removeChild(innerGroup.firstChild);
      }

      const logo = document.createElementNS("http://www.w3.org/2000/svg", "image");
      logo.setAttribute("width", "72");
      logo.setAttribute("height", "72");
      logo.setAttribute("x", "0");
      logo.setAttribute("y", "0");
      logo.setAttribute("preserveAspectRatio", "xMidYMid meet");
      logo.setAttribute("href", logoAssetUrl);
      logo.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", logoAssetUrl);

      innerGroup.appendChild(logo);
      innerGroup.dataset.logoSwapped = "true";
      svg.dataset.logoSwapped = "true";
    });
  }

  function setupSpinTriggerDismiss() {
    const trigger = document.getElementById("wheelify-spin-trigger-cc");
    if (!trigger || trigger.dataset.dismissInit === "true") return;

    const computedPos = window.getComputedStyle(trigger).position;
    const hasOffset =
      trigger.style.bottom || trigger.style.top || trigger.style.left || trigger.style.right;
    if (!hasOffset && computedPos === "static") {
      trigger.style.position = "relative";
    }

    const closeBtn = document.createElement("button");
    closeBtn.type = "button";
    closeBtn.innerText = "×";
    closeBtn.setAttribute("aria-label", "Dismiss spin to win");
    closeBtn.className = "wheelify-spin-dismiss";
    Object.assign(closeBtn.style, {
      position: "absolute",
      top: "-8px",
      left: "-8px",
      width: "24px",
      height: "24px",
      borderRadius: "50%",
      border: "none",
      background: "#ffffff",
      color: "#333333",
      fontSize: "16px",
      lineHeight: "24px",
      cursor: "pointer",
      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "0"
    });

    closeBtn.addEventListener("click", event => {
      event.stopPropagation();
      trigger.disabled = true;
      trigger.style.opacity = "0";
      trigger.style.pointerEvents = "none";
      trigger.remove();
      closeBtn.remove();
    });

    trigger.appendChild(closeBtn);
    trigger.dataset.dismissInit = "true";
  }

  setTimeout(translateElements, 2000);

  const observer = new MutationObserver(() => translateElements());
  observer.observe(document.body, { childList: true, subtree: true });
}); 
